import {IPNSOrganization} from '@portal-ng/PNSModels/';

export interface IPNSOrganizationSearchResults {
  totalRecords: number;
  results: IPNSOrganization[];
}
